import React, { FC, useEffect, useRef } from 'react';
import { Button, notification, Spin } from 'antd';
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useGetFaqByIdQuery, useUpdateFaqMutation } from 'app/services/edpApiV1/faq';
import moment from 'moment';
import { PICKER_DATE_MASK, SERVER_DATE_MASK } from 'shared/constants';
import { FaqStatuses } from 'shared/enums/FAQ';
import { DEFAULT_CATEGORY_VALUE } from 'shared/constants/faq';
import { addNotifications } from 'shared/helpers/utils';
import { IUpdateFAQ } from 'shared/types/faq.types';
import style from './index.module.scss';

const InfoFaq: FC = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const { data, isLoading, isFetching } = useGetFaqByIdQuery({ id: Number(id) });
  const [updateFaqQuery, { isLoading: isUpdateLoading }] = useUpdateFaqMutation();
  const navigate = useNavigate();

  const faqData = useRef<HTMLDivElement>(null);
  const fromArchive = searchParams.get('fromArchive');

  useEffect(() => {
    if (data && faqData.current) {
      faqData.current.innerHTML = data.content;
    }
  }, [data]);

  const navigateAfterSuccess = () => {
    navigate('/faq');
  };

  const unpublicateFaq = async () => {
    if (!data) {
      notification.error({ message: 'Остутствуют данные ' });
      return;
    }

    const newFaq: IUpdateFAQ = {
      id: data.id,
      created: data.created,
      title: data.title,
      content: data.content,
      status: FaqStatuses.UNPUBLICATED,
      categoryId: data.category ? data.category.id : DEFAULT_CATEGORY_VALUE,
    };

    await addNotifications(
      updateFaqQuery(newFaq),
      'Вопрос-ответ снят с публикации',
      'Ошибка при  снятии с публикации',
      navigateAfterSuccess,
    );
  };

  return (
    <Spin spinning={isLoading || isFetching}>
      <div className={style['faq-info']}>
        <div className={style.top}>
          <h3>{data?.title}</h3>
          <div className={style.buttons}>
            <Button onClick={unpublicateFaq} loading={isUpdateLoading}>
              Снять с публикации
            </Button>
            <Link to={'/faq'}>
              <Button>Ок</Button>
            </Link>
          </div>
        </div>
        <div ref={faqData} className={style.data}></div>
        <div className={style.info}>
          <p>Дата создания: {moment(data?.updateDate, SERVER_DATE_MASK).format(PICKER_DATE_MASK)}</p>
          <p>
            Автор: {data?.author.lastName} {data?.author.name} {data?.author.middleName}
          </p>
          {!fromArchive ? (
            <>
              <p>
                Дата последнего редактирования: {moment(data?.updateDate, SERVER_DATE_MASK).format(PICKER_DATE_MASK)}
              </p>
              <p>Статус: {data?.status}</p>
            </>
          ) : null}
        </div>
      </div>
    </Spin>
  );
};

export default InfoFaq;
